import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';

const PrescriptionPreview = () => {
  const { patientId } = useParams();
  const { token } = useAuth();
  const [prescriptions, setPrescriptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${API_PATH}/medicalrecords/patients/${patientId}/records`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPrescriptions(res.data || []);
      } catch (err) {
        console.error('Failed to load prescription data:', err);
      }
    };

    fetchData();
  }, [patientId, token]);
return (
  <div className="container my-4">
    <h4 className="text-center mb-4">Prescription Preview</h4>
    {prescriptions.map((record, index) => (
      <div key={index} className="card p-3 mb-3 shadow">
        <p><strong>Date:</strong> {record.recordDate}</p>
        <p><strong>Diagnosis:</strong> {record.diagnosis}</p>
        <p><strong>Treatment:</strong> {record.treatment}</p>
        <p><strong>Notes:</strong> {record.notes}</p>

        <p><strong>Prescriptions:</strong></p>
        {record.prescriptions.map((p, i) => (
          <div key={i} className="mb-2">
            <strong>Medicine:</strong> {p.medicineName}<br />
            <strong>Duration:</strong> {p.durationInDays} days<br />
            <strong>Total Qty:</strong> {p.totalQuantity}<br />
            <strong>Dosage:</strong>
            <ul className="mb-0">
              {p.dosage.map((dose, dIndex) => (
                <li key={dIndex}>
                  {dose.quantity} - {dose.timing} ({dose.relativeToMeal.replace('_', ' ')})
                </li>
              ))}
            </ul>
          </div>
        ))}

        <p><strong>Recommended Tests:</strong></p>
        {record.recommendedTests.map((test, tIndex) => (
          <div key={tIndex} className="mb-2">
            <strong>Test Name:</strong> {test.testName}<br />
            <strong>Description:</strong> {test.testDescription}<br />
            <strong>Notes:</strong> {test.notes}
          </div>
        ))}
      </div>
    ))}
  </div>
);

};

export default PrescriptionPreview;
